/* Extra keepers — HEllO EDC, 23 Oct 2026. Replaces the Easify Options app.

   PLAY with FLEXA comes with 2 extra pairs of keepers, THE F1 APEX with 1.
   The shopper picks their colours from the strap's OTHER colourways (never
   the colour of the strap they are buying — they already have that one), and
   can choose which keeper is fitted on the strap: the matching one
   (standard) or one of the extra colours.

   How many, and which product, comes from the product metafield
   custom.keepers_required, emitted by snippets/buy-buttons.liquid as
   <script data-wc-keepers>. No app, no per-store option ids.

   What reaches the order (line item properties on the strap):
     Extra keepers: Burnish (Brown), Atlantic (Navy)
     Fitted keeper: Burnish (Brown)        (only when not the matching one;
       then the matching colour takes its place under Extra keepers, so
       on a Pebble strap: Extra = Pebble (Grey), Atlantic (Navy))

   Looks and behaves like the other options on the page:
     - phone: a button in the option grid ("EXTRA KEEPERS / Choose 2") that
       opens a bottom sheet, the same way Lug Width opens its drawer;
     - wider screens: the same picker inline, under the option accordions.
   Add to cart is held until the count is right (assets/wc-guided-atc.js
   asks window.__wcKeepers.ok()),
   and the sticky bar's add is held here too. */

(function () {
  'use strict';

  if (window.__wckp) return;
  window.__wckp = true;

  var cfg = null;
  var picks = [];          /* chosen colour values, in the order picked */
  var fitted = '';         /* '' = matching keeper; otherwise one of picks */
  var sheet = null;
  var flash = '';

  function readCfg() {
    if (cfg) return cfg;
    var el = document.querySelector('script[data-wc-keepers]');
    if (!el) return null;
    try { cfg = JSON.parse(el.textContent); } catch (e) { return null; }
    cfg.required = parseInt(cfg.required, 10) || 0;
    if (!cfg.required || !cfg.values || cfg.values.length < 2) { cfg = null; return null; }
    return cfg;
  }

  function isMobile() { return window.innerWidth < 750; }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  /* "Burnish (Brown)" -> "Burnish" for tight spaces */
  function short(v) { return String(v || '').replace(/\s*\(.*\)\s*$/, '').trim(); }

  /* ---------- the strap colour ---------- */

  function strapColour() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return '';
    var name = (cfg.option || '').toLowerCase();
    var radios = vs.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      var fs = radios[i].closest('[data-option-index]');
      var idx = fs ? fs.getAttribute('data-option-index') : null;
      if (String(idx) === String(cfg.index)) return radios[i].value;
      var n = (radios[i].name || '').toLowerCase();
      if (name && n.indexOf(name) > -1) return radios[i].value;
    }
    var sel = vs.querySelector('select[name*="' + (cfg.option || 'Color') + '"]');
    if (sel) return sel.value;
    try {
      var v = JSON.parse((vs.querySelector('script[data-selected-variant]') || {}).textContent || 'null');
      if (v && v.options && cfg.index != null) return v.options[cfg.index] || '';
    } catch (e) {}
    return '';
  }

  function choices() {
    var mine = strapColour();
    return cfg.values.filter(function (v) { return v !== mine; });
  }

  /* Drop anything that is no longer offered (the strap colour changed to it). */
  function prune() {
    var ok = choices();
    picks = picks.filter(function (p) { return ok.indexOf(p) > -1; });
    if (fitted && picks.indexOf(fitted) < 0) fitted = '';
  }

  function complete() { return picks.length === cfg.required; }

  /* ---------- swatches ---------- */

  function swatchStyle(v) {
    var map = window.colorSwatchMap || {};
    var c = map[v];
    if (!c) return '';
    return c.indexOf('url(') === 0
      ? 'background-image:' + c + ';background-size:cover;background-position:center'
      : 'background-color:' + c;
  }

  /* ---------- the picker body (shared by sheet and inline) ---------- */

  function need() { return cfg.required - picks.length; }

  function lead() {
    var n = cfg.required;
    return 'Choose ' + (n === 1 ? '1 colour' : n + ' colours') + ' for your extra ' +
      (n === 1 ? 'pair' : 'pairs') + ' of keepers';
  }

  function status() {
    if (flash) return flash;
    if (complete()) return 'All set: ' + picks.join(', ');
    return picks.length + ' of ' + cfg.required + ' chosen';
  }

  function bodyHTML() {
    var mine = strapColour();
    var opts = choices();
    var h = '<p class="wckp-lead">' + esc(lead()) + '</p>' +
      '<p class="wckp-sub">Your ' + esc(short(mine) || 'strap') + ' keeper already comes with the strap, so it isn\'t listed here.</p>' +
      '<div class="wckp-grid" role="group" aria-label="Extra keeper colours">';
    opts.forEach(function (v) {
      var on = picks.indexOf(v) > -1;
      h += '<button type="button" class="wckp-chip' + (on ? ' is-on' : '') + '" data-wckp-pick="' + esc(v) + '" aria-pressed="' + on + '">' +
        '<span class="wckp-chip__sw" style="' + esc(swatchStyle(v)) + '"></span>' +
        '<span class="wckp-chip__name">' + esc(v) + '</span>' +
        (on ? '<span class="wckp-chip__tick" aria-hidden="true">✓</span>' : '') +
        '</button>';
    });
    h += '</div>' +
      '<p class="wckp-status' + (flash ? ' is-warn' : complete() ? ' is-done' : '') + '" aria-live="polite">' + esc(status()) + '</p>';

    if (picks.length) {
      h += '<div class="wckp-fit"><p class="wckp-fit__label">Fitted on your strap</p><div class="wckp-fit__row" role="radiogroup">' +
        fitBtn('', 'Matching' + (mine ? ' (' + short(mine) + ')' : '')) +
        picks.map(function (p) { return fitBtn(p, short(p)); }).join('') +
        '</div><p class="wckp-fit__note">' + (picks.length === 1 ? 'The other one comes as a spare pair in the box.' : 'The others come as spare pairs in the box.') + '</p></div>';
    }
    return h;
  }

  function fitBtn(val, label) {
    var on = fitted === val;
    return '<button type="button" class="wckp-fit__opt' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on +
      '" data-wckp-fit="' + esc(val) + '">' + esc(label) + '</button>';
  }

  /* ---------- the order fields ---------- */

  function fieldsHost() {
    var host = document.querySelector('[data-wckp-fields]');
    if (host) return host;
    var vs = document.querySelector('variant-selects');
    var root = (vs && vs.closest('product-info')) || document.querySelector('product-info') || (vs && vs.parentNode);
    if (!root) return null;
    host = document.createElement('div');
    host.setAttribute('data-wckp-fields', '');
    host.hidden = true;
    root.appendChild(host);
    return host;
  }

  function writeFields() {
    var host = fieldsHost();
    if (!host) return;
    var form = document.querySelector('product-info form[data-type="add-to-cart-form"], form[data-type="add-to-cart-form"]');
    var formAttr = form && form.id ? ' form="' + esc(form.id) + '"' : '';
    /* What actually goes in the box. When a chosen colour is fitted on the
       strap, the matching keeper comes off and travels as an extra instead. */
    var mine = strapColour();
    var extras = picks.map(function (p) { return (fitted && p === fitted && mine) ? mine : p; });
    var h = '';
    if (extras.length) h += '<input type="hidden" name="properties[Extra keepers]" value="' + esc(extras.join(', ')) + '"' + formAttr + '>';
    if (fitted) h += '<input type="hidden" name="properties[Fitted keeper]" value="' + esc(fitted) + '"' + formAttr + '>';
    if (host.getAttribute('data-sig') !== h) { host.setAttribute('data-sig', h); host.innerHTML = h; }
  }

  /* ---------- phone: grid button + sheet ---------- */

  /* One line under EXTRA KEEPERS: "Choose 2", then "1 of 2", then the
     colours. wc-guided-atc.js asks window.__wcKeepers.ok() whether it's done. */
  function caption() {
    if (complete()) return picks.map(short).join(', ');
    return picks.length ? picks.length + ' of ' + cfg.required : 'Choose ' + cfg.required;
  }

  function ensureButton() {
    var grid = document.querySelector('.mobile-variant-buttons-grid');
    if (!grid) return null;
    var btn = grid.querySelector('[data-wckp-btn]');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      /* the --rebel-keepers class is what wc-guided-atc.js looks for */
      btn.className = 'mobile-variant-btn mobile-variant-btn--rebel-keepers wckp-btn';
      btn.setAttribute('data-wckp-btn', '');
      btn.setAttribute('aria-haspopup', 'dialog');
      btn.innerHTML =
        '<span class="mobile-variant-btn__label">EXTRA KEEPERS</span>' +
        '<span class="mobile-variant-btn__value-option"></span>';
      grid.appendChild(btn);
    }
    setText(btn.querySelector('.mobile-variant-btn__value-option'), caption());
    btn.classList.toggle('is-selected', complete());
    if (complete()) btn.setAttribute('data-user-selected', 'true'); else btn.removeAttribute('data-user-selected');
    return btn;
  }

  function ensureSheet() {
    if (sheet && document.body.contains(sheet)) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'wckp-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="wckp-sheet__bg" data-wckp-close></div>' +
      '<div class="wckp-sheet__box" role="dialog" aria-modal="true" aria-labelledby="wckp-h">' +
        '<div class="wckp-sheet__head"><b id="wckp-h">Extra keepers</b>' +
          '<button type="button" class="wckp-x" data-wckp-close aria-label="Close">×</button></div>' +
        '<div class="wckp-body" data-wckp-body></div>' +
        '<button type="button" class="wckp-done" data-wckp-done>Done</button>' +
      '</div>';
    document.body.appendChild(sheet);
    return sheet;
  }

  function paintSheet() {
    if (!sheet || sheet.hidden) return;
    var body = sheet.querySelector('[data-wckp-body]');
    var h = bodyHTML();
    if (body.getAttribute('data-sig') !== h) { body.setAttribute('data-sig', h); body.innerHTML = h; }
    var done = sheet.querySelector('[data-wckp-done]');
    setText(done, complete() ? 'Done' : 'Choose ' + need() + ' more');
    done.classList.toggle('is-ready', complete());
  }

  function openSheet() {
    ensureSheet();
    sheet.hidden = false;
    document.documentElement.classList.add('wckp-lock');
    paintSheet();
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
  }

  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    sheet.hidden = true;
    document.documentElement.classList.remove('wckp-lock');
  }

  /* ---------- wider screens: inline ---------- */

  function ensureInline() {
    var vs = document.querySelector('variant-selects');
    if (!vs || !vs.parentNode) return null;
    var box = document.querySelector('[data-wckp-inline]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'wckp-inline';
      box.setAttribute('data-wckp-inline', '');
      box.innerHTML = '<p class="wckp-inline__title">Extra keepers</p><div data-wckp-body></div>';
    }
    if (box.previousElementSibling !== vs) vs.parentNode.insertBefore(box, vs.nextSibling);
    var body = box.querySelector('[data-wckp-body]');
    var h = bodyHTML();
    if (body.getAttribute('data-sig') !== h) { body.setAttribute('data-sig', h); body.innerHTML = h; }
    return box;
  }

  /* ---------- paint everything ---------- */

  function paint() {
    if (!readCfg()) return;
    try {
      prune();
      writeFields();
      ensureButton();
      ensureInline();
      paintSheet();
    } catch (e) {
      window.__wckpError = e;
      if (window.console && console.warn) console.warn('[WC] keepers:', e);
    }
  }

  /* ---------- choosing ---------- */

  var flashTimer = null;
  function say(msg) {
    flash = msg;
    clearTimeout(flashTimer);
    flashTimer = setTimeout(function () { flash = ''; paint(); }, 2600);
  }

  function pick(v) {
    var i = picks.indexOf(v);
    if (i > -1) {
      picks.splice(i, 1);
    } else if (picks.length < cfg.required) {
      picks.push(v);
    } else if (cfg.required === 1) {
      picks = [v];                               /* one pair: tapping another swaps */
    } else {
      say('You can choose ' + cfg.required + '. Tap a chosen colour to remove it first.');
    }
    if (fitted && picks.indexOf(fitted) < 0) fitted = '';
    paint();
  }

  /* ---------- public, for wc-guided-atc.js and wc-customise.js ---------- */

  window.__wcKeepers = {
    applies: function () { return !!readCfg(); },
    ok: function () { return !readCfg() || complete(); },
    caption: function () { return readCfg() ? caption() : 'Select'; },
    open: function () { if (isMobile()) openSheet(); else { var b = ensureInline(); if (b && b.scrollIntoView) b.scrollIntoView({ block: 'center', behavior: 'smooth' }); } },
    state: function () { return { picks: picks.slice(), fitted: fitted }; }
  };

  /* ---------- wiring ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || !readCfg()) return;
    var b;
    if (t.closest('[data-wckp-btn]')) {
      e.preventDefault();
      e.stopPropagation();           /* not a theme drawer: keep the theme's handler out of it */
      openSheet();
      return;
    }
    if ((b = t.closest('[data-wckp-pick]'))) { e.preventDefault(); pick(b.getAttribute('data-wckp-pick')); return; }
    if ((b = t.closest('[data-wckp-fit]'))) { e.preventDefault(); fitted = b.getAttribute('data-wckp-fit'); paint(); return; }
    if (t.closest('[data-wckp-done]')) {
      e.preventDefault();
      if (complete()) closeSheet();
      else { say('Choose ' + need() + ' more colour' + (need() === 1 ? '' : 's') + ' to continue.'); paint(); }
      return;
    }
    if (t.closest('[data-wckp-close]')) { e.preventDefault(); closeSheet(); }
  }, true);

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') closeSheet();
  });

  /* Hold any add to cart (main button, sticky bar) until the count is right,
     and open the picker with the reason instead of a dead click. On window,
     capture phase, so it runs before wc-cart.js's own submit handler. */
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    if (!readCfg() || complete()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    say('Please choose ' + need() + ' more keeper colour' + (need() === 1 ? '' : 's') + ' first.');
    paint();
    window.__wcKeepers.open();
  }, true);

  var timer = null;
  function soon() { clearTimeout(timer); timer = setTimeout(paint, 60); }

  function start() {
    if (!readCfg()) return;
    paint();
    document.addEventListener('change', soon, true);
    window.addEventListener('resize', soon);
    var root = document.querySelector('product-info') || document.body;
    if (window.MutationObserver && root) {
      /* The theme rebuilds the option grid on every variant change: put the
         button straight back, before the browser paints. */
      new MutationObserver(function () {
        if (!document.querySelector('[data-wckp-btn]') || !document.querySelector('[data-wckp-inline]')) paint();
      }).observe(root, { childList: true, subtree: true });
    }
    [300, 1000].forEach(function (ms) { setTimeout(paint, ms); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
